import * as React from "react";

import { isNullOrEmpty } from "../Utils/Arrays";

import { Toggle } from "../Anim/AnimToggle";
import { ToggleChild } from "../Anim/AnimToggleChild";
import * as classNames from "classNames";
import { UnmountClosed } from "react-collapse";

export interface IValidationErrorsContainerProps {
    validationErrors: string[];
    hide?: boolean;
    id?: string;
    isServerError?: boolean;
    serverErrorType?: ServerErrorType;
    errorsWrapperCss?: string;
}

export const enum ServerErrorType {
    Alert,
    Warning,
    Info,
}

export interface IValidationErrorsContainerState {}

export class ValidationErrorsContainer extends React.Component<
    IValidationErrorsContainerProps,
    IValidationErrorsContainerState
> {
    constructor(props: IValidationErrorsContainerProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const showMessage = !this.props.hide && !isNullOrEmpty(this.props.validationErrors);

        const errors = this.props.validationErrors;
        if (isNullOrEmpty(errors)) {return null;}
        let errorsCode: any;

        if (this.props.isServerError) {
            errorsCode = errors.map((e: string, index: number) => <li key={index}>{e}</li>);
        } else {
            errorsCode = errors.map((e: string, index: number) => (
                <p className="error mb-0" key={index}>
                    {e}
                </p>
            ));
        }

        const className = classNames(
            this.props.isServerError ? "alert" : "inline-error-message",
            this.props.errorsWrapperCss,
            this.getAlertType()
        );

        return (
            <UnmountClosed isOpened={showMessage}>
                <div className={className} role={"alert"} id={this.props.id}>
                    {this.props.isServerError && (
                        <div>
                            {errors.length > 1 && <ul className="list mt-0 mb-0">{errorsCode}</ul>}
                            {errors.length === 1 && <p>{errors[0]}</p>}
                        </div>
                    )}
                    {!this.props.isServerError && errorsCode}
                </div>
            </UnmountClosed>
        );
    }

    private getAlertType(): string {
        switch (this.props.serverErrorType) {
            case ServerErrorType.Warning:
                return "warning";
            case ServerErrorType.Info:
                return "info";
            default:
                return "error";
        }
    }
}
